<ng-container *ngIf="linkStatus=='valid'">
    <app-onboarding-login (newItemEvent)="dataEmitfromChild($event)" *ngIf="page=='login'"></app-onboarding-login>
    <app-onboarding-forgetpassword (newItemEvent)="dataEmitfromChild($event)"
        *ngIf="page=='forgetpassword'"></app-onboarding-forgetpassword>
    <app-onboarding-register (newItemEvent)="dataEmitfromChild($event)"
        *ngIf="page=='register'"></app-onboarding-register>

</ng-container>